import React from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  {
    to: "/doctor-dashboard",
    label: "Home",
    icon: "icon-Layout-4-blocks",
    isActive: (pathname) => pathname === "/doctor-dashboard",
  },
  {
    to: "/add-case",
    label: "Add Case",
    icon: "icon-Barcode-read",
    isActive: (pathname) => pathname === "/add-case" || pathname.startsWith("/edit-case"),
  },
  {
    to: "/draft-cases",
    label: "Drafts",
    icon: "icon-Compiling",
    isActive: (pathname) => pathname === "/draft-cases",
  },
  {
    to: "/view-cases?r_type=patient",
    label: "Cases",
    icon: "icon-Settings-1",
    isActive: (pathname) => pathname === "/view-cases",
  },
];

export default function DoctorBottomNav() {
  const { pathname } = useLocation();

  return (
    <nav className="admin-bottom-nav" aria-label="Doctor navigation">
      {NAV_ITEMS.map((item) => {
        const active = item.isActive(pathname);

        return (
          <Link
            key={item.to}
            to={item.to}
            className={`admin-bottom-nav__item${active ? " is-active" : ""}`}
            aria-current={active ? "page" : undefined}
            onClick={() => document.body.classList.remove("sidebar-open")}
          >
            <i className={item.icon}>
              <span className="path1"></span>
              <span className="path2"></span>
            </i>
            <span className="admin-bottom-nav__label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
